/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Dropdown, Row, Form} from 'react-bootstrap';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {variables} from 'utils/constant';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import SuggestedFestivalForm from './FestivalForm';

interface CategoryItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}

const SuggestedFestivals = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.SUGGESTFESTIVAL;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editCategory, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  const [sortColumn, setSortColumn] = useState('id');
  console.log('🚀 ~ Festivals ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');

  const [sortDirection, setSortDirection] = useState('desc');
  console.log('🚀 ~ Festivals ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<CategoryItemType>();
  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);
  const [resetSearchFlag, setResetSearchFlag] = useState(false);

  useEffect(() => {
    ApiUtils.getSuggestedFestivalList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
    )
      .then(async (data: any): Promise<void> => {
        setCategoryList(data as CategoryItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });

    setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    iseAddCategory,
    pageSize,
    search,
    isStatusChange,
  ]);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };
  const handleDeleteCategory = async (id: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: `You won't be able to revert this!<br><br>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      ApiUtils.deleteFestival(id)

        // eslint-disable-next-line unused-imports/no-unused-vars
        .then(async data => {
          await Swal.fire({
            title: 'Deleted',
            text: (data as any).message,
            icon: 'success',
          });
          ApiUtils.getSuggestedFestivalList(
            `?page=${pageValue}&page_size=${pageSize}`,
          )
            .then((data: any) => {
              if (data?.current_page > data?.last_page) {
                setPageValue(data?.last_page);
              }
              setCategoryList(data as CategoryItemType);
              setTotalRecords(data?.total);
            })
            .catch((error: any) => {
              toast.error(error.message);
            });
        })
        .catch((error: any) => {
          void Swal.fire({
            title: 'Error!',
            text: error?.response?.data?.message,
            icon: 'error',
          });
        });
      setResetSearchFlag(true);
    }
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  // const handleSortByColumn = (column: string): void => {
  //   let newSortDirection = 'asc';

  //   if (column === sortColumn) {
  //     newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
  //   } else {
  //     newSortDirection = 'desc';
  //   }
  //   ApiUtils.getCategoryList(
  //     `?page=${pageValue}&page_size=${pageSize}&sort_column=${column}&sort_direction=${newSortDirection}`,
  //   )
  //     .then(async (data: any): Promise<void> => {
  //       setCategoryList(data as CategoryItemType);
  //       setSortDirection(newSortDirection);
  //       setSortColumn(column);

  //       setTotalRecords((data as CategoryItemType)?.data?.total);
  //     })
  //     .catch((error: any) => {
  //       toast.error(error.message);
  //     });
  // };
  const toggleCategoryStatus = async (
    id: number,
    statusId: number,
    name: string,
  ): Promise<void> => {
    // Function to toggle category status

    try {
      // Implement logic to toggle category status
      await ApiUtils.updateFestival({id, status: statusId, name})
        .then(() => toast.success('Status updated successfully !'))
        .catch((error: any) => {
          toast.error(error.response?.data?.message);
        });

      ApiUtils.getSuggestedFestivalList(
        `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
      )
        .then(async (data: any): Promise<void> => {
          setCategoryList(data as CategoryItemType);
          setTotalRecords(data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
  };

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };
  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  // const handleCheckboxChange = (productId: number): void => {
  //   let updatedSelectedProductIds: number[] = [];

  //   if (selectedProductIds.includes(productId)) {
  //     // Uncheck child, remove it from the array
  //     updatedSelectedProductIds = selectedProductIds.filter(
  //       id => id !== productId,
  //     );
  //   } else {
  //     // Check child, add it to the array
  //     updatedSelectedProductIds = [...selectedProductIds, productId];
  //   }

  //   setSelectedProductIds(updatedSelectedProductIds);
  // };

  // useEffect(() => {
  //   dispatch(setProductIds(selectedProductIds));
  //   if (selectedProductIds.length > 0) {
  //     setIsCheckboxChanged(true);
  //   } else {
  //     setIsCheckboxChanged(false);
  //   }
  // }, [selectedProductIds]);
  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Festivals',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);
  const columns = [
    // {
    //   id: 'parentBox', // Give the column a unique ID
    //   Header: () => (
    //     <input
    //       className="parentCheckbox"
    //       type="checkbox"
    //       checked={allChecked} // This binds the checked state to `allChecked`
    //       value="0"
    //       onChange={() => {
    //         // handleSelectAll();
    //       }}
    //     />
    //   ),
    //   disableFilters: true,
    //   filterable: true,
    //   accessor: '',
    //   Cell: (cell: any) => {
    //     return (
    //       <div className="d-inline-flex align-items-center gap-3">
    //         <input
    //           className={
    //             selectedProductIds.includes(cell.row.original.id)
    //               ? 'checked-class'
    //               : 'unchecked-class'
    //           }
    //           value={cell.row.original.id}
    //           type="checkbox"
    //           checked={selectedProductIds.includes(cell.row.original.id)}
    //           onChange={() => {
    //             handleCheckboxChange(cell.row.original.id);
    //           }}
    //         />
    //       </div>
    //     );
    //   },
    // },
    {
      Header: 'Name',
      disableFilters: true,
      filterable: true,
      accessor: 'name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'status',
      Cell: (cellProps: any) => {
        const toggleStatus = async (newStatusId: number): Promise<void> => {
          const currentStatusId = cellProps?.value;

          // Only allow toggling if the status is Pending or when explicitly switching between Approved and Rejected
          if (
            currentStatusId === variables.REQUEST_PENDING_STATUS_ID ||
            currentStatusId !== newStatusId
          ) {
            try {
              // Perform the status update
              await toggleCategoryStatus(
                cellProps?.cell?.row?.original?.id,
                newStatusId,
                cellProps?.cell?.row?.original?.name,
              );
            } catch (error) {
              console.error('Error toggling status:', error);
            }
          }
        };

        return (
          <div className="form-check form-switch d-flex gap-1">
            <Form.Group className="d-flex align-items-center">
              {/* Radio button for Approved */}
              <Form.Check
                type="radio"
                id="radioApproved"
                name="statusRadio"
                label="Approve"
                checked={
                  cellProps.value === variables.REQUEST_APPROVED_STATUS_ID
                }
                onChange={async () =>
                  await toggleStatus(variables.REQUEST_APPROVED_STATUS_ID)
                }
                // disabled={
                //   cellProps.value === variables.REQUEST_PENDING_STATUS_ID
                // }
                className="form-radio-md me-3" // Added margin to the right
              />

              {/* Radio button for Rejected */}
              <Form.Check
                type="radio"
                id="radioRejected"
                name="statusRadio"
                label="Reject"
                checked={
                  cellProps.value === variables.REQUEST_REJECTED_STATUS_ID
                }
                onChange={async () =>
                  await toggleStatus(variables.REQUEST_REJECTED_STATUS_ID)
                }
                // disabled={
                //   cellProps.value === variables.REQUEST_PENDING_STATUS_ID
                // }
                className="form-radio-md"
              />
            </Form.Group>

            <div>
              <span
                className={`badge ${
                  cellProps.value === variables.REQUEST_APPROVED_STATUS_ID
                    ? 'badge-success' // Green badge for Approved
                    : cellProps.value === variables.REQUEST_REJECTED_STATUS_ID
                      ? 'badge-danger' // Red badge for Rejected
                      : 'badge-warning' // Yellow badge for Pending
                }`}>
                {cellProps.value === variables.REQUEST_APPROVED_STATUS_ID
                  ? variables.REQUEST_APPROVED_STATUS // Display "Approved"
                  : cellProps.value === variables.REQUEST_REJECTED_STATUS_ID
                    ? variables.REQUEST_REJECTED_STATUS // Display "Rejected"
                    : variables.REQUEST_PENDING_STATUS}{' '}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      Header: 'Added By',
      disableFilters: true,
      filterable: true,
      accessor: 'user',
      Cell: (cellProps: any) => {
        console.log('🚀 ~ cellProps:', cellProps.value);
        return (
          <>
            {cellProps?.value?.first_name} {cellProps?.value?.last_name}
          </>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              {/* <li>
                <Dropdown.Item
                  onClick={() => {
                    setEditCategory(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  Edit
                </Dropdown.Item>
              </li> */}
              <li>
                <Dropdown.Item
                  onClick={async () => {
                    await handleDeleteCategory(cellProps?.id);
                  }}
                  className="remove-list">
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted" />
                  Delete
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Suggested Festivals</h4>
        </div>
        <div id="couponsList">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    // isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search Festivals..."
                    buttonText="Add Festival"
                    onClick={() => {
                      setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editCategory.id !== undefined ? 'Edit Festival' : 'Add Festival'
          }
          modalBody={
            <>
              <SuggestedFestivalForm
                handleClose={modalToggle}
                editCategory={editCategory}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
              />
            </>
          }
        />
      </Container>
    </div>
  );
};

export default SuggestedFestivals;
